import { Platform } from '@/types/api/platforms';

const platformDisplayOrder: Platform[] = [
  Platform.Acast,
  Platform.YouTube,
  Platform.Instagram,
  Platform.TikTok,
];

export function sortByPlatformDisplayOrder<T extends { plays: { platform: Platform | string }[] }>(data: T) {
  return {
    ...data,
    plays: [...data.plays].sort((a, b) => {

        // Put "Podcast Players" at the top
        if (a.platform === 'Podcast Players') return -1;
        if (b.platform === 'Podcast Players') return 1;

        const indexA = platformDisplayOrder.indexOf(a.platform as Platform);
        const indexB = platformDisplayOrder.indexOf(b.platform as Platform);

        // if platform is unknown put it at the end of the list
        const sortA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
        const sortB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;

        return sortA - sortB;
    }),
  };
}

export const getFirstDisplayPlatform = <T extends { plays: { platform: Platform }[] }>(data: T): Platform | null => {
  const sortedData = sortByPlatformDisplayOrder(data);
  return sortedData.plays[0]?.platform ?? null;
} 
